<template>
    <v-snackbar v-model="show">
        <v-row class="justify-space-between align-center">
            <span class="ml-4">{{ content }}</span>
            <v-btn color="pink" text @click="show = false">Close</v-btn>
        </v-row>
    </v-snackbar>
</template>

<script>
import EventBus from '@/utils/EventBus';

/**
 * PopUp component implements a simple popup that appears when the topic 'popup'
 * is emitted over the EventBus, and shows the message provided as argumnet.
 * 
 * Ex.: EventBus.$emit('popup', 'My message');
 */
export default {
    name: 'PopUp',
    data: () => ({
        content: '',
        show: false
    }),
    mounted() {
        EventBus.$on("popup", (content) => {
            this.content = content;
            this.show = true;
        });
    }
}
</script>